import { Roles } from "@/helpers/roles";

export const documentTypeRoutes = [
    {
        path: '',
        name: 'adminDocumentTypes',
        component: () => import('@/pages/back/registry/document-types/DocumentTypeList.vue'),
        meta: {
            requiresAuth: true,
            roles: [Roles.ADMIN, Roles.DOCUMENT_TYPE_READ],
        },
    },
    {
        path: 'create',
        name: 'adminDocumentTypeCreate',
        component: () => import('@/pages/back/registry/document-types/DocumentTypeCreate.vue'),
        meta: {
            requiresAuth: true,
            roles: [Roles.ADMIN, Roles.DOCUMENT_TYPE_CREATE],
        },
    },
    {
        path: 'edit/:code',
        name: 'adminDocumentTypeEdit',
        component: () => import('@/pages/back/registry/document-types/DocumentTypeEdit.vue'),
        meta: {
            requiresAuth: true,
            roles: [Roles.ADMIN, Roles.DOCUMENT_TYPE_EDIT],
        },
    },
    {
        path: 'view/:code',
        name: 'adminDocumentTypeView',
        component: () => import('@/pages/back/registry/document-types/DocumentTypeView.vue'),
        meta: {
            requiresAuth: true,
            roles: [Roles.ADMIN, Roles.DOCUMENT_TYPE_READ],
        },
    },
];
